import { SituacaoDoMacon } from 'common/types/Irmao';
import { ResultadoBusca } from '../../common/types/Busca'

export const OPCOES_DE_BUSCAR_EM: {descricao: string, valor: ResultadoBusca['resultType']}[] = [
	{
		descricao: 'Lojas',
		valor: 'loja',
	},
	{
		descricao: 'Potências',
		valor: 'potencia',
	},
	{
		descricao: 'Serviços',
		valor: 'servico',
	},
	{
		descricao: 'Irmaos',
		valor: 'irmao',
	},
	{
		descricao: 'Cunhadas',
		valor: 'esposa',
	},
]

export function obterFiltroDefault(): CamposDoFiltroDeBusca {
	return {
		busca: '',
		minhaSomar: true,
		situacoes: ['Regular'],
		loja: null,
		buscarEm: [],
		recentes: false,
	}
}

export function obterParametrosDeNovosServicos(): CamposDoFiltroDeBusca {
	return {
		...obterFiltroDefault(),
		buscarEm: ['servico'],
		recentes: true,
	}
}

export type CamposDoFiltroDeBusca = {
	busca: string
	minhaSomar: boolean
	situacoes: SituacaoDoMacon[]
	buscarEm: ResultadoBusca['resultType'][]
	loja: {
		value: string
		text: string
	} | null
	recentes: boolean
};